import BidClasses from './BidClasses';

export default BidClasses;
